module.exports = __webpack_public_path__ + "static/media/logo.d44b5a73.svg";